import axios from 'axios'
import router from '../router'
import Cookies from './cookies'
import { getApiDomain, TOKEN } from './index'

const Http = axios.create({
  baseURL: getApiDomain()
})

const errorLogger = (apiErrorJSONMessage) => {
  if (typeof apiErrorJSONMessage === 'undefined') {
    return '<strong>Sorry we could not contact the server. Try again</strong>'
  }
  // most likely this throws an html message
  if (typeof apiErrorJSONMessage === 'string' && apiErrorJSONMessage.indexOf('html') > 0) {
    return '<strong>Sorry we could not contact the server. Try again</strong>'
  }
  // check if the type of apiErrorJSONMessage that was passed is an object
  if (typeof apiErrorJSONMessage !== 'object') {
    // then just toast the error message and return
    return apiErrorJSONMessage
  }
  for (var prop in apiErrorJSONMessage) {
    var errorValue = apiErrorJSONMessage[prop]
    // test if the current prop has an _ in it string value
    var _pattern = /_/
    if (_pattern.test(prop)) {
      // split the string based on the _ and join the string based with a space
      prop = prop.split('_').join(' ')
    }
    // capitalize the prop
    prop = prop.replace(/\b\w/g, function (s) {
      return s.toUpperCase()
    })
    // create the right error messages
    const errorMessage = prop.concat(' ', errorValue)
    return errorMessage
  }
}
const userCookieToken = Cookies.getCookieName(TOKEN)
if (userCookieToken) {
  Http.defaults.headers.common.Authorization = `JWT ${userCookieToken}`
}

Http.interceptors.request.use((config) => {
  const loader = document.getElementById('hr-loader')
  if (loader) {
    loader.style.display = 'block'
  }
  return config
}, (error) => { return Promise.reject(error) })

/* eslint-disable */
Http.interceptors.response.use((response) => {
  if (response.status === 200 || response.status === 201) {
    const loader = document.getElementById('hr-loader')
    if (loader) {
      loader.style.display = 'none'
    }
  }
  return response
}, (error) => {
  // Add a 401 response interceptor
  switch(error.response.status) {
    case 40001: //TODO add logic to return to a different page
      router.push('/login')
      break
    case 403:
      router.push('/no-access')
      break
    case 400:
      error.response.data = errorLogger(error.response.data)
    default:
      return Promise.reject(error)
  }

})

export default Http



// WEBPACK FOOTER //
// ./src/utils/http.js